export enum RescheduleModalStatesEnum {
  loading = 'loading',
  rescheduleOptionSelection = 'select',
  confirmRescheduleAtNextClassTime = 'confirmRescheduleAtNextClassTime',
  polling = 'polling',
  availableSlots = 'availableSlots',
  noSlotsAvailable = 'noSlotsAvailable',
  success = 'success',
  contactRM = 'contactRM',
  checkIfStudentIsInformed = 'checkIfStudentIsInformed',
  requestTeacherToInformStudent = 'requestTeacherToInformStudent',
  selectRescheduleDateTime = 'selectRescheduleDateTime',
}

export enum ClassRescheduleOptionsEnum {
  nextTime = 'nextTime',
  beforeNextClass = 'beforeNextClass',
}

export const RESCHEDULE_CLASS_IMAGE_PATH =
  '/images/student-dashboard/reschedule-class/'

export const SUCCESSFUL_CANCELLATION_TOAST_ON_INCOMPLETE_PAGE_QUERY_NAME =
  'showToast'

export const RESCHEDULE_OPTIONS_TOOLTIP: Record<
  'teacher' | 'student',
  { rescheduleToNextClass: string; rescheduleBeforeNextClass: string }
> = {
  teacher: {
    rescheduleToNextClass:
      "If you select this option, all future classes starting from this class will be rescheduled according to student's weekly schedule. This class will be canceled. Student will be notified about the change.",
    rescheduleBeforeNextClass:
      'If you select this option, you will have to select a new date & time for this class. The schedule of all other classes will remain same. Student will be notified about the change.',
  },
  student: {
    rescheduleToNextClass:
      'If you select this option, all your future classes will be rescheduled as per your weekly recurring schedule. Your upcoming class will be canceled. You can check weekly schedule in your dashboard.',
    rescheduleBeforeNextClass:
      'If you select this option, you will have to select a new date & time for your upcoming class. The schedule of other future classes will remain same.',
  },
}
